import { render, staticRenderFns } from "./DataFieldsChangedDialog.vue?vue&type=template&id=5e36a9b2"
import script from "./DataFieldsChangedDialog.vue?vue&type=script&lang=ts"
export * from "./DataFieldsChangedDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports